import React from 'react';
import './ContextMenu.css';

const ContextMenu = ({ position, onClose, onAction }) => {
  const handleMenuClick = (action) => {
    onAction(action);
    onClose();
  };

  return (
    <>
      {/* Invisible overlay to detect clicks outside */}
      <div 
        className="context-menu-overlay" 
        onClick={onClose}
        onContextMenu={(e) => {
          e.preventDefault();
          onClose();
        }}
      />
      
      {/* The actual context menu */}
      <div 
        className="context-menu" 
        style={{ 
          top: `${position.y}px`, 
          left: `${position.x}px` 
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="context-menu-item" onClick={() => handleMenuClick('new-folder')}>
          <span className="menu-icon">📂</span>
          <span className="menu-label">New Folder</span>
          <span className="menu-shortcut">Ctrl+Shift+N</span>
        </div>
        
        <div className="context-menu-separator"></div>
        
        <div className="context-menu-item" onClick={() => handleMenuClick('open-terminal')}>
          <span className="menu-icon">📟</span>
          <span className="menu-label">Open Terminal Here</span>
          <span className="menu-shortcut">Ctrl+Alt+T</span>
        </div>
        
        <div className="context-menu-item" onClick={() => handleMenuClick('scan-viruses')}>
          <span className="menu-icon">🛡️</span>
          <span className="menu-label">Scan for Viruses</span>
        </div>
        
        <div className="context-menu-separator"></div>
        
        
        <div className="context-menu-item" onClick={() => handleMenuClick('inspect')}>
          <span className="menu-icon">🔍</span>
          <span className="menu-label">Inspect Element</span>
          <span className="menu-shortcut">F12</span>
        </div>
        
        <div className="context-menu-separator"></div>
        
        <div className="context-menu-item" onClick={() => handleMenuClick('refresh')}>
          <span className="menu-icon">🔄</span>
          <span className="menu-label">Refresh Desktop</span>
          <span className="menu-shortcut">F5</span>
        </div>
      </div>
    </>
  );
};

export default ContextMenu;
